module.exports = __webpack_public_path__ + "img/brandstory_info.d27582f2.png";